import { render, staticRenderFns } from "./UploadOrdersTable.vue?vue&type=template&id=0e21f919"
import script from "./UploadOrdersTable.vue?vue&type=script&lang=js"
export * from "./UploadOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./UploadOrdersTable.vue?vue&type=style&index=0&id=0e21f919&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports